// src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/tailwind.css";
import "./assets/custom.css";
import * as Sentry from "@sentry/vue";
import { EnvironmentConfig } from "./config/environment";
import { captureAttribution } from "./utils/attribution";
import { initAnalytics } from "./services/analytics.service";

const app = createApp(App);

if (
  EnvironmentConfig.monitoring.errorReporting &&
  EnvironmentConfig.monitoring.sentryDsn
) {
  Sentry.init({
    app,
    dsn: EnvironmentConfig.monitoring.sentryDsn,
    environment: EnvironmentConfig.environment,
    tracesSampleRate: EnvironmentConfig.isProduction ? 0.1 : 1.0,
    tracePropagationTargets: ["localhost", /^\//],
    release: EnvironmentConfig.buildInfo.version,
    beforeSend(event) {
      if (EnvironmentConfig.isLocal) {
        return null;
      }
      return event;
    },
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
    ],
    debug: !EnvironmentConfig.isProduction,
    initialScope: {
      tags: {
        component: "vue-app",
        environment: EnvironmentConfig.environment,
        version: EnvironmentConfig.buildInfo.version,
      },
    },
  });
}

// Capture ad-campaign params from the landing URL, then boot analytics
// (both are no-ops unless configured/tagged).
captureAttribution();
initAnalytics();

app.use(router).mount("#app");
